import { InvoiceByCounterpartySortValue } from "@common/types/invoice";
import {
    useWorkspaceUserCache,
    WORKSPACE_USER_CACHE_KEYS,
} from "../useWorkspaceUserCache";

export function useInvoicesByCounterpartyPageSortingCache(): [
    InvoiceByCounterpartySortValue | undefined,
    (value: InvoiceByCounterpartySortValue | undefined) => void,
] {
    const [value, setter] =
        useWorkspaceUserCache<InvoiceByCounterpartySortValue>(
            WORKSPACE_USER_CACHE_KEYS.INVOICES_BY_COUNTERPARTY_PAGE_SORTING_CACHE_KEY,
        );

    return [
        value,
        (sorting: InvoiceByCounterpartySortValue | undefined) => {
            setter(sorting);
        },
    ];
}
